import { dataProps } from './properties'

export const setLetterTemplateList = (state, payload) => {
    state.list = payload
}    

export const setLetterTemplateData = (state, payload) => {
    state.props = payload
} 

export const resetLetterTemplateData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/letterTemplate/mutations.js